export default "__VITE_ASSET__B9crDwsr__"